import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const Column = ({
  children, className, lg, lgOffset, lgPull, lgPush, md, mdOffset,
  mdPull, mdPush, xl, xlPull, xlPush, xlOffset, xs, xsOffset, xsPush, xsPull,
}) => {
  const obj = {};
  if (xs) { obj[`col-xs-${xs}`] = true; }
  if (xsOffset) { obj[`offset-xs-${xsOffset}`] = true; }
  if (xsPush) { obj[`push-xs-${xsPush}`] = true; }
  if (xsPull) { obj[`pull-xs-${xsPull}`] = true; }
  if (md) { obj[`col-md-${md}`] = true; }
  if (mdOffset) { obj[`offset-md-${mdOffset}`] = true; }
  if (mdPush) { obj[`push-md-${mdPush}`] = true; }
  if (mdPull) { obj[`pull-md-${mdPull}`] = true; }
  if (lg) { obj[`col-lg-${lg}`] = true; }
  if (lgOffset) { obj[`offset-lg-${lgOffset}`] = true; }
  if (lgPush) { obj[`push-lg-${lgPush}`] = true; }
  if (lgPull) { obj[`pull-lg-${lgPull}`] = true; }
  if (xl) { obj[`col-xl-${xl}`] = true; }
  if (xlOffset) { obj[`offset-xl-${xlOffset}`] = true; }
  if (xlPush) { obj[`push-xl-${xlPush}`] = true; }
  if (xlPull) { obj[`pull-xl-${xlPull}`] = true; }

  const classes = cns(obj, className);

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

Column.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  lg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  lgOffset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  lgPull: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  lgPush: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  md: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mdOffset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mdPull: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mdPush: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xl: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xlOffset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xlPull: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xlPush: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xs: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xsOffset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xsPull: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  xsPush: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Column.defaultProps = {
  children: null,
  className: '',
  lg: null,
  lgOffset: null,
  lgPull: null,
  lgPush: null,
  md: null,
  mdOffset: null,
  mdPull: null,
  mdPush: null,
  xl: null,
  xlOffset: null,
  xlPull: null,
  xlPush: null,
  xs: null,
  xsOffset: null,
  xsPull: null,
  xsPush: null,
};

export default Column;
